import { formatDistanceToNow } from "date-fns"
import { ptBR } from "date-fns/locale"

/**
 * Format a date as a relative time (e.g. "2 hours ago")
 * @param date Date to format
 * @returns Formatted relative time string
 */
export function formatRelativeTime(date: Date | string): string {
  const dateObj = typeof date === "string" ? new Date(date) : date

  return formatDistanceToNow(dateObj, {
    addSuffix: true,
    locale: ptBR,
  })
}